export default {
  namespaced: true,
  dmp: {
    title: "DMP",
    name: "Name",
    panel_model: "Model",
    panel_mac_addr: "MAC Address",
    panel_serial_num: "Serial Number",
    panel: "Panel",
    autoDetectPanel: "Auto-detect panel(s)",
    autoDetectPanelHint: "Automatically use the alarm's unit panel(s)",
    dateRange: "Date range",
    dateRangeNone: "None",
    dateRangeLast30: "Last 30 days",
    dateRangeLast60: "Last 60 days",
    dateRangeHint: "Calculated from the moment the alarm view is opened",
    template: "Template",
    panels: "Panels",
    host: "Host",
    port: "Port",
    client_password: "Client Password",
    remote_control_password: "Remote Control Password",
    listening_port: "Listening Port",
    facilities: "Facilities",
    eventDefinition: "Event definition",
    event_code: "Event Code",
    alarm_type_sbo: "Alarm Type (SBO)",
    description: "Description",
    zone: "Zone",
    num_conact_id: "Contact ID Account Number",
    creation_date: "Creation Date",
    isRecovered: "Recovered",
    recovered_yes: "Yes",
    recovered_no: "No",
    date: "Date",
    masterAccounts: "master accounts",
    masterAccount: "master account",
    first_name: "first name",
    last_name: "last name",
    link: "link",
    username: "username",
    token: "token",
    password: "password",
    token_expired: "token expiration",
    email: "email",
    sites: "sites",
    site: "site",
    address: "address",
    latitude: "latitude",
    longitude: "longitude",
    timeZone: "timezone",
    profile: "profile",
    profiles: "profiles",
    calendar: "calendar",
    serialNumber: "serial number",
    actions: "actions",
    schemaTypes: "schema types",
    schema_type: "schema type",
    display_name: "display name",
    id: "id",
    devicesSection: "devices",
    gateway_id: "gateway id",
    schema_actions: "schema actions",
    typeAlarm: "alarm type",
    typeAlarms: "alarm types",
    priority: "priority",
    checkRemoteUser: "check remote user",
    dispatchAlarm: "dispatch alarm",
    alarms: "alarms",
    state: "state",
    creation_time: "creation time",
    units: "units",
    center: "center",
    sector: "sector",
    device: "device",
    schemaEvent: "event",
    time: "time",
    logs: "logs",
    channel: "channel",
    name_panel: "panel name",
    events: "events",
    syncCorrectly: "synchronized correctly",
    status: "Status",
    panel_status: "panel status",
    router_status: "router status",
    instance_host: "Instance Host",
    rules: "Rules",
    code: "Code",
    event: "Event",
    event_id: "Event ID",
    value: "Value",
    zones_pgm: "Zone / PGM",
    pgm_output: "PGM / Output",
    partition: "Partition",
    alias: "Alias",
    syncPanel: "Sync panel",
    syncPanelWarning: "The synchronization may take a few minutes",
    syncing: "Syncing",
    withoutProfile: "The panel does not have a profile assigned",
    reconnect: "Reconnect",
    restart: "Restart",
    rebuild: "Rebuild",
    profile_name: "Profile",
    type: "Type",
    category: "Category",
    active: "Active",
    activate: "Activate",
    deactivate: "Deactivate",
    close: "Close",
    open: "Open",
    bypass: "Bypass",
    enable: "Enable",
    panelOffline: "Panel is offline",
    panelStatusArmed: "Armed",
    panelStatusDisarmed: "Disarmed",
    panelStatusOffline: "Offline",
    arm: "Arm",
    disarm: "Disarm",
    armPanel: "Arm panel",
    disarmPanel: "Disarm panel",
    arming: "Arming",
    disarming: "Disarming",
    armedCorrectly: "Armed correctly",
    disarmedCorrectly: "Disarmed correctly",
    uuid: "UUID",
    connected: "Connected",
    disconnected: "Disconnected",
    deviceType: 'Device type',
    deviceId: "Device id",
    deviceName: "Device name",
    eventType: "Event type",
    areaId: "Area id",
    userId: "User Id",
    alarmType: "Alarm Type",
    areaArmed: "Armed",
    areaDisarmed: "Disarmed",
    enabled: "Enabled",
    disabled: "Disabled",
    area: "Area",
    eventDate: "Date event",
    servers: "Servers",
    url: "Url",
    count: "Num. of instances",
    panelHost: "Panel Host",
    panelAccount: "Panel Account",
    panelRemoteKey: "Panel Remote Key",
    alarmId: "Alarm Id",
    activating: "Activating",
    deactivating: "Deactivating",
    saving: "Saving...",
    syncDevices: "Sync devices",
    syncDevicesSuccess: "Devices synchronized successfully",
    syncDevicesError: "Error synchronizing devices",
    tag: "Tag",
    tags: "Tags",
    searchResults: "Resultados de la búsqueda",
    noResults: "Sin resultados",
    required: "Required",
    isRecovered: "Recovered",
    enabled_zones_audit: "Enable zones audit",
    days_zones_audit: "Zones audit days",
    enabled_areas_audit: "Enable areas audit",
    days_areas_audit: "Areas audit days",
    dateAndTimezone: "Date & Time zone",
    current: "Current",
    messages: {
      executeCommandConfirm: "Execute '%command%' command to '%device%'?",
      commandExecutedSuccess: "command executed successfully",
      commandExecutedError: "error executing '%command%' command",
      areYouSureTo: "Are you sure to %action% %device%?",
      areYouSure: "Are you sure to execute '%action%' in %device%?",
      categoryGroupChangeWarning: "Apply the category to all items, including those that already have a different one?",
      tagAppliedSuccess: "Tag applied successfully",
      tagRemovedSuccess: "Tag removed successfully",
    },
    devices: {
      area: {
        actions: {
          Arm: 'Armed',
          Disarm: 'Disarmed'
        },
        title: 'area'
      },
      output: {
        actions: {
          Momentary: 'momentary',
          Off: 'off',
          Pulse: 'pulse',
          Steady: 'steady',
          'Temporal 3': 'Temporal 3'
        },
        title: 'output'
      },
      zone: {
        actions: {
          Bypass: 'bypass',
          Reset: 'reset'
        },
        title: 'zone'
      },
      zone24h: {
        actions: {
          Bypass: 'bypass',
          Reset: 'reset'
        },
        title: 'zone 24h'
      },
      panel: {
        title: 'panel',
        actions: {
          'Arm Panel': 'Arm Panel',
          'Disarm Panel': 'Disarm Panel',
          'Alarm silence': 'Alarm Silence',
          'Sensor reset': 'Sensor Reset'
        }
      },
      door: {
        title: 'door',
        actions: {
          'Door Access': 'Door Access',
          'Lock Door': 'Lock Door',
          'Unlock Door': 'Unlock Door'
        }
      }
    },
    deviceStatuses: {
      ARMED: 'Armed',
      DISARMED: 'Disarmed',
      NORMAL: 'Normal',
      OPEN: 'Open',
      BYPASSED: 'Bypassed',
      OFF: 'Off',
      ON: 'On',
      OFFLINE: 'Offline',
      ONLINE: 'Online',
      LOCKED: 'Locked',
      UNLOCKED: 'Unlocked',
      TROUBLE: 'Trouble',
    },
    panelInfo: {
      panel: 'Panel',
      tamper: 'Tamper',
      acPower: 'AC Power',
      battery: 'Battery',
      printer: 'Printer',
      wireless: 'Wireless',
      phoneLine1: 'Phone Line 1',
      phoneLine2: 'Phone Line 2',
    },
    wizard: {
      add: {
        title: "Add DMP Wizard",
      },
      edit: {
        title: "Edit DMP Wizard",
      },
      steps: {
        general: "General",
        users: "Users",
        communicationPaths: "Communication Paths",
      }
    },
    config: "Configuration",
    configSections: {
      users: "Users",
      communicationPaths: "Communication Paths",
      general: "General Settings",
      areaInformation: "Area Information",
      outputInformation: "Output Information",
      deviceSetup: "Device Setup",
      outputOptions: "Output Options",
      areaSchedules: "Area Schedules",
      timeSchedules: "Time Schedules",
      bellOptions: "Bell Options",
      networkOptions: "Network Options",
      remoteOptions: "Remote Options",
      holidayDates: "Holiday Dates",
      outputGroups: "Output Groups",
      systemOptions: "System Options",
      profiles: "Profiles",
      zoneInformation: "Zone Information",
    },
    outputInformation: {
      title: "Output Information",
      outputs: "Outputs",
      addOutput: "Add Output",
      editOutput: "Edit Output",
      noOutputsConfigured: "No outputs configured",
      outputNumber: "Output Number",
      outputName: "Output Name",
      outputDetails: "Output Details",
      description: "Description",
      loadingOutputs: "Loading outputs...",
      messages: {
        deleteConfirm: "Are you sure you want to delete this output?",
        limitReached: "Limit Reached",
        maxOutputsAllowed: "Maximum outputs allowed",
        validationError: "Validation Error",
        outputNumberExists: "Output number already exists",
        outputSavedSuccess: "Output saved successfully",
        outputsLoadError: "Failed to load outputs",
        outputDeleteSuccess: "Output deleted successfully",
        outputDeleteError: "Failed to delete output",
        outputSaveError: "Failed to save output",
        outputAddedSuccess: "Output added successfully",
        outputUpdatedSuccess: "Output updated successfully",
        syncSuccess: "Outputs synchronized successfully",
        syncError: "Failed to synchronize outputs"
      }
    },
    outputGroups: {
      title: "Output Groups",
      groups: "Groups",
      addGroup: "Add Group",
      editGroup: "Edit Group",
      noGroupsConfigured: "No groups configured",
      groupNumber: "Group Number",
      groupName: "Group Name",
      messages: {
        deleteConfirm: "Are you sure you want to delete this group?",
        limitReached: "Limit Reached",
        maxGroupsAllowed: "Maximum groups allowed",
        validationError: "Validation Error",
        groupNumberExists: "Group number already exists",
        groupSavedSuccess: "Group saved successfully",
        groupsLoadError: "Failed to load groups",
        groupDeleteSuccess: "Group deleted successfully",
        groupDeleteError: "Failed to delete group",
        groupSaveError: "Failed to save group"
      }
    },
    outputOptions: {
      title: "Output Options",
      settings: "Settings",
      save: "Save Changes",
      options: "Options",
      energySaving: "Energy Saving",
      outputs: "Outputs",
      cutoffOutputs: "Cutoff Outputs",
      cutoffOutputsRange: "Range: 0, 1-6",
      cutoffTime: "Cutoff Time",
      cutoffTimeRange: "Range: 0, 55-95",
      heatSaverTemp: "Heat Saver Temperature",
      coolSaverTemp: "Cool Saver Temperature",
      temperatureRange: "Range: 0, 55-95",
      commFailOutput: "Communication Fail Output",
      fireAlarmOutput: "Fire Alarm Output",
      fireTroubleOutput: "Fire Trouble Output",
      panicAlarmOutput: "Panic Alarm Output",
      ambushOutput: "Ambush Output",
      entryDelayOutput: "Entry Delay Output",
      beginExitOutput: "Begin Exit Output",
      endExitOutput: "End Exit Output",
      readyOutput: "Ready Output",
      phoneTroubleOutput: "Phone Trouble Output",
      lateToCloseOutput: "Late to Close Output",
      deviceFailedOutput: "Device Failed Output",
      sensorResetOutput: "Sensor Reset Output",
      closingWaitOutput: "Closing Wait Output",
      disarmedOutput: "Disarmed Output",
      armAlarmOutput: "Arm Alarm Output",
      supervisoryAlarmOutput: "Supervisory Alarm Output",
      armedHomePerimeterOutput: "Home/Perimeter Output",
      armedAllAwayOutput: "All/Away Output",
      armedSleepOutput: "Sleep Output",
      carbonMonoxideOutput: "Carbone Monoxide Output",
      lockdownOutput: "Lockdown Output",
      zoneMonitorOutput: "Zone Monitor Output",
      loadingOutputs: "Loading output options...",
      messages: {
        saveSuccess: "Output options saved successfully",
        saveError: "Failed to save output options",
        loadError: "Failed to load output options",
        syncSuccess: "Output options synchronized successfully",
        syncError: "Failed to synchronize output options"
      }
    },
    systemOptions: {
      title: "System Options",
      settings: "Settings",
      save: "Save Changes",
      saving: "Saving...",
      options: "Options",
      miscellaneousOptions: "Miscellaneous Options",
      languages: "Languages",
      timeChange: "Time Change",
      delays: "Delays",
      wireless: "Wireless",
      advancedOptions: "Advanced Options",
      systemArmingType: "System Arming Type",
      instantArm: "Instant Arm",
      closingWait: "Closing Wait",
      resetSwingerBypass: "Reset Swinger Bypass",
      enableKeypadPanicKeys: "Enable Keypad Panic Keys",
      enhancedZoneTest: "Enhanced Zone Test",
      send16Characters: "Send 16 Character Names",
      useFalseAlarmQuestion: "Use False Alarm Question",
      allowOwnUserCodeChange: "Allow Own User Code Change",
      panicSupervision: "Panic Supervision",
      keypadArmedLed: "Keypad Armed LED",
      swingerBypassTrips: "Swinger Bypass Trips",
      bypassLimit: "Bypass Limit",
      weatherZipCode: "Weather Zip Code",
      occupiedPremises: "Occupied Premises",
      primaryProgrammingLang: "Primary Programming Language",
      secondaryProgrammingLang: "Secondary Programming Language",
      primaryUserLang: "Primary User Language",
      secondaryUserLang: "Secondary User Language",
      hoursFromGMT: "Hours from GMT",
      timeChangeOption: "Time Change",
      zoneActivityHours: "Zone Activity Hours",
      entryDelay1: "Entry Delay 1",
      entryDelay2: "Entry Delay 2",
      entryDelay3: "Entry Delay 3",
      entryDelay4: "Entry Delay 4",
      crossZoneTime: "Cross Zone Time",
      zoneRetardDelay: "Zone Retard Delay",
      powerFailDelay: "Power Fail Delay",
      wirelessHouseCode: "Wireless House Code",
      troubleAudible: "Trouble Audible",
      detectWirelessJamming: "Detect Wireless Jamming",
      latchSupervisory: "Latch Supervisory",
      eolResistor: "EOL Resistor Selector",
      useCelsiusTemperature: "Celsuis Temperature",
      observeDST: "Observe DST",
      encryptionSettings: "1100 Wireless Encryption",
      encryptionPassphrase: "1100 Passphrase",
      loadingSystemOptions: "Loading system options...",
      timeChangeOptions: {
        receiver: "Receiver",
        noChange: "No Time Change",
        secureCom: "SecureCom",
      },
      encryptionSettingsOptions: {
        none: "None",
        all: "All",
        both: "Both"
      },
      armingTypes: {
        area: "Area",
        all: "All",
        guest: "Guest",
        home: "Home"
      },
      keypadLedOptions: {
        any: "Any",
        day: "Day",
        minimum: "Minimum"
      },
      languages: {
        title: "Languages",
        none: "None",
        english: "English",
        spanish: "Spanish",
        french: "French",
        czech: "Czech",
        greek: "Greek",
        dutch: "Dutch"
      },
      troubleAudibleOptions: {
        any: "Any",
        day: "Day",
        minimum: "Min"
      },
      messages: {
        saveSuccess: "System options saved successfully",
        saveError: "Failed to save system options",
        loadError: "Failed to load system options",
        validationError: "Validation Error",
        validationErrorText: "Please correct the errors in the form",
        syncSuccess: "System options synchronized successfully",
        syncError: "Failed to synchronize system options"
      }
    },
    areaInformation: {
      globalSettings: "Global Settings (applies to all areas)",
      saveGlobalSettings: "Save Global Settings",
      exitDelay: "Exit Delay",
      burglaryBellOutput: "Burglary Bell Output",
      earlyMorningAmbush: "Early Morning Ambush",
      closingCheck: "Closing Check",
      areaSchedules: "Area Schedules",
      closingCode: "Closing Code",
      anyBypass: "Any Bypass",
      areas: "Areas",
      addArea: "Add Area",
      editArea: "Edit Area",
      noAreasConfigured: "No areas configured",
      loadingAreas: "Loading areas...",
      areaDetails: "Area Details",
      areaNumber: "Area Number",
      areaName: "Area Name",
      accountNumber: "Account Number",
      accountNumberHint: "4-digit account number (optional)",
      badZones: "Bad Zones",
      armedOutput: "Armed Output",
      lateOutput: "Late Output",
      lateArmDelay: "Late/Arm Delay",
      twoManRule: "Two Man Rule",
      options: "Options",
      openCloseReports: "Open/Close Reports",
      autoArming: "Auto Arming",
      autoDisarm: "Auto Disarm",
      bankSafeAndVault: "Bank Safe and Vault",
      commonArea: "Common Area",
      armFirst: "Arm First",
      cardPin: "Card + Pin",
      bypassOptions: {
        bypass: "Bypass",
        forceArm: "Force Arm",
        refuseArm: "Refuse Arm"
      },
      noYes: {
        no: "No",
        yes: "Yes"
      },
      messages: {
        deleteConfirm: "Are you sure you want to delete this area?",
        deleteConfirmText: "This action cannot be undone",
        limitReached: "Limit Reached",
        maxAreasAllowed: "Maximum 99 areas allowed",
        validationError: "Validation Error",
        areaNumberExists: "Area number already exists",
        globalSettingsSaved: "Global settings saved successfully",
        globalSettingsError: "Failed to save global settings",
        areasSavedSuccess: "Area saved successfully",
        areaAddedSuccess: "Area added successfully",
        areaUpdatedSuccess: "Area updated successfully",
        areasLoadError: "Failed to load areas",
        areasReloadSuccess: "Areas reloaded successfully",
        areasReloadError: "Could not reload areas. Please try again.",
        areaDeleteSuccess: "Area deleted successfully",
        areaDeleteError: "Failed to delete area",
        areaSaveError: "Failed to save area",
        syncSuccess: "Areas synchronized successfully",
        syncError: "Failed to synchronize areas"
      }
    },
    outputGroups: {
      title: "Output Groups",
      groups: "Groups",
      addGroup: "Add Group",
      editGroup: "Edit Group",
      groupDetails: "Output Group Details",
      noGroupsConfigured: "No groups configured",
      groupNumber: "Group Number",
      groupName: "Group Name",
      outputNumber: "Output Number",
      loadingGroups: "Loading output groups...",
      messages: {
        deleteConfirm: "Delete Group",
        deleteConfirmText: "Are you sure you want to delete this output group?",
        limitReached: "Limit Reached",
        maxGroupsAllowed: "Maximum groups allowed",
        validationError: "Validation Error",
        groupNumberExists: "Group number already exists",
        groupAddedSuccess: "Output group added successfully",
        groupUpdatedSuccess: "Output group updated successfully",
        groupSavedSuccess: "Output group saved successfully",
        groupsLoadError: "Failed to load output groups",
        groupDeleteSuccess: "Output group deleted successfully",
        groupDeleteError: "Failed to delete output group",
        groupSaveError: "Failed to save output group",
        atLeastOneOutput: "At least one output must be configured for the group",
        syncSuccess: "Output groups synchronized successfully",
        syncError: "Failed to synchronize output groups"
      }
    },
    holidayDates: {
      title: "Holiday Dates",
      addHoliday: "Add Holiday",
      editHoliday: "Edit Holiday",
      noHolidaysConfigured: "No holiday dates configured",
      loadingHolidays: "Loading holidays...",
      number: "Number",
      name: "Name",
      class: "Class",
      date: "Date",
      holidayDate: "Holiday Date",
      description: "Description",
      selectClass: "Select a class",
      holidayDetails: "Holiday Details",
      messages: {
        deleteConfirm: "Are you sure you want to delete this holiday?",
        limitReached: "Limit Reached",
        maxHolidaysAllowed: "Maximum 99 holidays allowed",
        validationError: "Validation Error",
        validationErrorText: "Please fill in all required fields correctly",
        numberExists: "Holiday number already exists",
        dateExists: "This date already exists",
        saveSuccess: "Holiday saved successfully",
        saveError: "Failed to save holiday",
        loadError: "Failed to load holiday dates",
        deleteSuccess: "Holiday deleted successfully",
        deleteError: "Failed to delete holiday",
        syncSuccess: "Holiday dates synchronized successfully",
        syncError: "Failed to synchronize holiday dates"
      }
    },
    users: {
      title: "Users",
      configuredUsers: "Configured Users",
      addUser: "Add User",
      editUser: "Edit User",
      noUsersConfigured: "No users configured",
      loadingUsers: "Loading users...",
      userNumber: "Number",
      userCode: "Code",
      userName: "Name",
      userPin: "User PIN",
      activeUser: "Active User",
      status: "Status",
      active: "Active",
      inactive: "Inactive",
      profiles: "Profiles",
      noProfiles: "No profiles",
      noProfile: "Not assigned",
      profile: "Profile",
      range: "Range: 1-9999",
      userCodeHint: "0-9a-z, max 12",
      userPinHint: "6 digits (optional)",
      userNameHint: "Max 20",
      userDetails: "User Details",
      messages: {
        deleteConfirm: "Are you sure you want to delete this user?",
        userSavedSuccess: "User saved successfully",
        userAddedSuccess: "User added successfully",
        userUpdatedSuccess: "User updated successfully",
        userDeleteSuccess: "User deleted successfully",
        usersLoadError: "Failed to load users",
        userSaveError: "Failed to save user",
        userDeleteError: "Failed to delete user",
        pinMustBe6Digits: "PIN must be exactly 6 digits or empty",
        userCodeOnlyAlphanumeric: "User code can only contain numbers and lowercase letters",
        profileOnlyNumbers: "Profile {number} can only contain numbers (1-3 digits)",
        userNumberExists: "User number already exists",
        userCodeExists: "User code already exists",
        atLeastOneProfile: "At least one profile must be provided"
      }
    },
    communicationPaths: {
      title: "Communication Paths",
      addPath: "Add Path",
      editPath: "Edit Communication Path",
      addCommunicationPath: "Add Communication Path",
      editCommunicationPath: "Edit Communication Path",
      noPathsConfigured: "No communication paths configured",
      loadingPaths: "Loading paths...",
      communicationPathDetails: "Communication Path Details",
      pathNumber: "Path Number",
      receiverIp: "Receiver IP",
      receiverPort: "Receiver Port",
      protocol: "Protocol",
      accountNumber: "Account Number",
      communicationTrouble: "Communication Trouble",
      doorAccess: "Door Access",
      selectProtocol: "Select Protocol",
      selectOption: "Select Option",
      tcp: "TCP",
      udp: "UDP",
      yes: "Yes",
      no: "No",
      deny: "Deny",
      pathNumberHint: "Enter path number (1-8)",
      receiverIpHint: "Enter receiver IP address",
      receiverPortHint: "Port",
      accountNumberHint: "4-digit account number (optional)",
      messages: {
        deleteConfirm: "Are you sure you want to delete this communication path?",
        deleteConfirmText: "This action cannot be undone",
        limitReached: "Limit Reached",
        maxPathsAllowed: "Maximum 8 communication paths allowed",
        pathSavedSuccess: "Communication path saved successfully",
        pathCreatedSuccess: "Communication path created successfully",
        pathUpdatedSuccess: "Communication path updated successfully",
        pathDeleteSuccess: "Communication path deleted successfully",
        pathsLoadError: "Failed to load communication paths",
        pathSaveError: "Failed to save communication path",
        pathDeleteError: "Failed to delete communication path",
        validationError: "Validation Error",
        pathNumberExists: "Path number already exists",
        ipPortExists: "IP and Port combination already exists",
        syncSuccess: "Communication paths synchronized successfully",
        syncError: "Failed to synchronize communication paths"
      }
    },
    remoteOptions: {
      title: "Remote Options",
      save: "Save Changes",
      saving: "Saving...",
      standard: "Standard",
      entre: "Entré",
      general: "General",
      dialer: "Dialer",
      network: "Network",
      cellular: "Cellular",
      mobileApplication: "Mobile Application",
      programSync: "Program Sync",
      entreSettings: "Entré Settings",
      remoteKey: "Remote Key",
      remoteDisarm: "Remote Disarm",
      armedAnswerRings: "Armed Answer Rings",
      disarmedAnswerRings: "Disarmed Answer Rings",
      pcModem: "PC Modem",
      alarmReceiver: "Alarm Receiver",
      serviceReceiver: "Service Receiver",
      allowNetworkRemote: "Allow Network Remote",
      encryptNetworkRemote: "Encrypt Network Remote",
      encryptNetworkRemoteWarning: "Warning: Enabling this option may disconnect the panel.",
      networkProgrammingPort: "Network Programming Port",
      allowCellularRemote: "Allow Cell Remote",
      encryptCellRemote: "Encrypt Cell Remote",
      encryptCellRemoteWarning: "Warning: Enabling this option may disconnect the panel.",
      firstGprsApn: "First GPRS APN",
      secondGprsApn: "Second GPRS APN",
      appKey: "App Key",
      sendLocalChanges: "Send Local Changes",
      remoteChangeIp: "Remote Change IP",
      remoteChangePort: "Remote Change Port",
      remotePhoneNumber: "Remote Phone Number",
      entreConnection: "Entré Connection",
      entreIncomingTcpPort: "Entré Incoming TCP Port",
      entreIp: "Entré IP",
      entreOutboundTcpPort: "Entré Outbound TCP Port",
      entreBackupIp: "Entré Backup IP",
      entreBackupTcpPort: "Entré Backup TCP Port",
      entreArmDisarmReports: "Entré Arm/Disarm Reports",
      entreZoneReports: "Entré Zone Reports",
      entreUserCommandReports: "Entré User Command Reports",
      entreDoorReports: "Entré Door Access Reports",
      entreSupervisoryReports: "Entré Supervisory Reports",
      entreCheckInMinutes: "Entré Check-in Minutes",
      entrePassphrase: "Entré Passphrase",
      none: "None",
      yes: "Yes",
      no: "No",
      dd: "DD",
      loadingRemoteOptions: "Loading remote options...",
      messages: {
        saveSuccess: "Remote options saved successfully",
        saveError: "Failed to save remote options",
        loadError: "Failed to load remote options",
        validationError: "Validation Error",
        validationErrorText: "Please correct the errors in the form before saving",
        invalidIpFormat: "Invalid IP address format",
        syncSuccess: "Remote options synchronized successfully",
        syncError: "Failed to synchronize remote options"
      }
    },
    bellOptions: {
      title: "Bell Options",
      optionsSection: "Options",
      miscellaneousOptions: "Miscellaneous Options",
      fireBellAction: "Fire Bell Action",
      burglaryBellAction: "Burglary Bell Action",
      supervisoryBellAction: "Supervisory Bell Action",
      panicBellAction: "Panic Bell Action",
      emergencyBellAction: "Emergency Bell Action",
      aux1BellAction: "Aux 1 Bell Action",
      aux2BellAction: "Aux 2 Bell Action",
      carbonMonoxideAction: "Carbon Monoxide Action",
      bellCutoffTime: "Bell Cutoff Time",
      bellCutoffTimeHint: "Range: 1-99",
      automaticBellTest: "Automatic Bell Test",
      bellOutput: "Bell Output",
      bellOutputHint: "Format: 000-999",
      loading: "Loading bell options",
      actions: {
        none: "None",
        steady: "Steady",
        pulse: "Pulse",
        temporal3: "Temporal 3",
        temporal4: "Temporal 4",
      },
      savedSuccessfully: "Bell options saved successfully",
      errorSaving: "Error saving bell options",
    },
    networkOptions: {
      title: "Network Options",
      options: "Options",
      wifiSettings: "Wi-Fi Settings",
      localIp: "Local IP Address",
      gateway: "Gateway Address",
      subnetMask: "Subnet Mask",
      dnsServer: "DNS Server",
      encryptionPassphrase: "Encryption Passphrase",
      listenPort734n: "734N Listen Port",
      passphrase734n: "734N Passphrase",
      ssid: "SSID",
      security: "Security",
      wifiPassword: "Wi-Fi Password",
      securityNone: "None",
      securityWep: "WEP",
      securityWpa: "WPA",
      dhcp: "DHCP",
      dhcpWarning: "Warning: Enabling this option may disconnect the panel.",
      loadingNetworkOptions: "Loading network options...",
      messages: {
        saveSuccess: "Network options saved successfully",
        saveError: "Failed to save network options",
        loadError: "Failed to load network options",
        validationError: "Validation Error",
        validationErrorText: "Please correct the errors in the form",
        syncSuccess: "Network options synchronized successfully",
        syncError: "Failed to synchronize network options"
      }
    },
    common: {
      success: "Success",
      error: "Error",
      loading: "Loading panel information",
      panelNotFound: "Panel not found",
      panelNotFoundMessage: "The requested panel could not be found",
      no: "No",
      yes: "Yes"
    },
    profiles: {
      title: "Profiles",
      configuredProfiles: "Configured Profiles",
      addProfile: "Add Profile",
      editProfile: "Edit Profile",
      deleteProfile: "Delete Profile",
      noProfilesConfigured: "No profiles configured",
      loadingProfiles: "Loading profiles...",
      profileNumber: "Number",
      profileName: "Name",
      name: "Name",
      number: "Number",
      profileNumberHint: "Range: 1-99",
      profileNameHint: "Max 20 characters",
      profileDetails: "Profile Details",
      generalSettings: "General Settings",
      areasAccess: "Areas & Access",
      schedules: "Schedules",
      permissions: "Permissions",
      armDisarmAreas: "Arm/Disarm Areas",
      armDisarmAreasHint: "Areas this profile can arm/disarm",
      accessAreas: "Access Areas",
      accessAreasHint: "Areas this profile has access to",
      outputGroup: "Output Group",
      outputGroupHint: "Range: 0-99",
      reArmDelay: "Re-Arm Delay",
      reArmDelayHint: "Delay in minutes (0-999)",
      inactiveUserAuditDays: "Inactive User Audit Days",
      inactiveUserAuditDaysHint: "Days before flagging inactive users (0-999)",
      schedule: "Schedule",
      arm: "Arm",
      disarm: "Disarm",
      alarmSilence: "Alarm Silence",
      lockdown: "Lockdown",
      doorLockUnlock: "Door Lock/Unlock",
      sensorReset: "Sensor Reset",
      doorAccess: "Door Access",
      armedAreas: "Armed Areas",
      outputsOnOff: "Outputs On/Off",
      zoneStatus: "Zone Status",
      bypassZones: "Bypass Zones",
      zoneMonitor: "Zone Monitor",
      systemStatus: "System Status",
      systemTest: "System Test",
      userCodes: "User Codes",
      setTime: "Set Time",
      displayEvents: "Display Events",
      serviceRequest: "Service Request",
      fireDrill: "Fire Drill",
      extend: "Extender",
      tempCode: "Temp Code",
      antiPassback: "Anti-Passback",
      easyArmDisarm: "Easy Arm/Disarm",
      useSecondaryLanguage: "Use Secondary Language",
      cardPlusPIN: "Card + PIN",
      wiFiSetup: "Wi-Fi Setup",
      technicianUser: "Technician User",
      lockdownOverride: "Lockdown Override",
      dualAuthority: "Dual Authority",
      privateDoors: "Private Doors",
      privateDoor: "Private Door",
      noSchedule: "Not assigned",
      noDoor: "Not assigned",
      messages: {
        deleteConfirm: "Are you sure you want to delete this profile?",
        deleteConfirmText: "This action cannot be undone",
        limitReached: "Limit Reached",
        maxProfilesAllowed: "Maximum 99 profiles allowed",
        validationError: "Validation Error",
        validationErrorText: "Please correct the errors in the form",
        profileNumberExists: "Profile number already exists",
        profileSavedSuccess: "Profile saved successfully",
        profileCreatedSuccess: "Profile created successfully",
        profileUpdatedSuccess: "Profile updated successfully",
        profileDeleteSuccess: "Profile deleted successfully",
        profilesLoadError: "Failed to load profiles",
        profileSaveError: "Failed to save profile",
        profileDeleteError: "Failed to delete profile",
        syncSuccess: "Profiles synchronized successfully",
        syncError: "Failed to synchronize profiles"
      }
    },
    zoneInformation: {
      title: "Zone Information",
      None: "None",
      zones: "Zones",
      zoneDetails: "Zone Details",
      standard: "Standard",
      action: "Action",
      wirelessVPlex: "Wireless/VPlex",
      advanced: "Advanced",
      addZone: "Add Zone",
      editZone: "Edit Zone",
      noZonesConfigured: "No zones configured",
      loadingZones: "Loading zones...",
      maxZonesReached: "Maximum zones limit reached (999)",

      // Standard tab
      zoneNumber: "Zone Number",
      zoneName: "Zone Name",
      zoneType: "Type",
      zoneTypeOptions: {
        none: "None",
        night: "Night",
        day: "Day",
        exit: "Exit",
        fire: "Fire",
        supervisory: "Supervisory",
        fireVerify: "Fire Verify",
        panic: "Panic",
        arming: "Arming",
        auxiliary1: "Auxiliary 1",
        auxiliary2: "Auxiliary 2",
        emergency: "Emergency",
      },
      area: "Area",
      unassigned: "*UNUSED*",
      followArea: "Follow Area",
      armedAreas: "Armed Areas",
      armedAreasHint: "Comma-separated area numbers",
      expanderSerialNumber: "Expander Serial Number",
      zoneLocation: "Zone Location",

      // Action tab
      doMessage: "DO Message",
      doOutputFireBell: "DO Output Fire Bell",
      doOutputAction: "DO Output Action",
      dsMessage: "DS Message",
      dsOutput: "DS Output",
      dsOutputAction: "DS Output Action",
      aoMessage: "AO Message",
      aoOutput: "AO Output",
      aoOutputAction: "AO Output Action",
      asMessage: "AS Message",
      asOutput: "AS Output",
      asOutputAction: "AS Output Action",

      // Message options
      messageOptions: {
        trouble: "Trouble",
        alarm: "Alarm",
        supervisory: "Supervisory",
        none: "None"
      },

      // Output action options
      outputActionOptions: {
        steady: "Steady",
        pulse: "Pulse",
        latch: "Latch"
      },

      // Wireless tab
      wireless: "Wireless",
      serialNumber: "Serial Number",
      contact: "Contact",
      normallyOpen: "Normally Open",
      supervisionTime: "Supervision Time",
      ledOperation: "LED Operation",
      disarmDisable: "Disarm Disable",
      wirelessPirPulseCount: "Wireless PIR Pulse Count",
      wirelessPirPulseSensitivity: "Wireless PIR Pulse Sensitivity",
      wirelessPirPetImmunity: "Wireless PIR Pet Immunity",

      // Sensitivity options
      sensitivityOptions: {
        low: "Low",
        medium: "Medium",
        high: "High"
      },

      // Pet immunity options
      petImmunityOptions: {
        full: "Full",
        partial: "Partial",
        none: "None"
      },

      // Wireless device types
      deviceTypes: {
        unknown: "Unknown",
        universal: "Universal Transmitter (1000000-1999999)",
        pir: "PIR Motion Detector (2000000-2999999)",
        glassbreak: "Glassbreak Detector (3000000-3999999)",
        holdup: "Hold-up Button (4000000-4999999)",
        keyfob: "Key Fob (5000000-5999999)",
        smoke_co: "Smoke/CO Detector (6000000-7999999)",
        four_zone_expander: "4-Zone Expander (8000000-8999999)",
        wireless_pir: "Wireless PIR (9000000-9999999)",
        repeater_1100r: "Repeater 1100R (13000000-13999999)"
      },

      // Advanced tab
      swingerBypass: "Swinger Bypass",
      zoneRetard: "Zone Retard",
      fastResponse: "Fast Response",
      crossZone: "Cross Zone",
      priority: "Priority",
      firePanelSlaveInput: "Fire Panel Slave Input",
      zoneRealTimeStatus: "Zone Real Time Status",
      trafficCount: "Traffic Count",
      lockdown: "Lockdown",
      zoneAuditDays: "Zone Audit Days",
      reportWithAccountNumber: "Report with Account Number",
      chimeSong: "Chime Song",
      prewarPresignal: "Prewarn Presignal",
      entryDelayNumber: "Entry Delay Number",
      number: "Number",
      loadingZones: "Loading zones...",
      name: "Name",
      type: "Type",
      messages: {
        deleteConfirm: "Are you sure you want to delete this zone?",
        deleteConfirmMessage: "This action cannot be undone",
        deleteConfirmText: "This action cannot be undone",
        limitReached: "Limit Reached",
        maxZonesAllowed: "Maximum 999 zones allowed",
        validationError: "Validation Error",
        validationErrorText: "Please correct the errors in the form",
        warning: "Warning",
        serialNumberIsKeyFob: "Serial Number is for a key fob",
        keyFobsCannotBeProgrammed: "Key fobs cannot be programmed from this screen",
        zoneNumberExists: "Zone number already exists",
        zoneSavedSuccess: "Zone saved successfully",
        zoneCreatedSuccess: "Zone created successfully",
        zoneCreateSuccess: "Zone created successfully",
        zoneUpdatedSuccess: "Zone updated successfully",
        zoneUpdateSuccess: "Zone updated successfully",
        zoneDeleteSuccess: "Zone deleted successfully",
        zonesLoadError: "Failed to load zones",
        zoneSaveError: "Failed to save zone",
        zoneDeleteError: "Failed to delete zone",
        syncSuccess: "Zones synchronized successfully",
        syncError: "Failed to synchronize zones",
        warning: "Warning"
      }
    },

    deviceSetup: {
      title: "Device Setup",
      addDevice: "Add Device",
      number: "Number",
      name: "Name",
      type: "Type",
      deviceDetails: "Device Details",
      general: "General",
      options734: "734 Options",
      loadingDevices: "Loading devices...",
      noDevicesConfigured: "No devices configured",
      maxDevicesReached: "Maximum number of devices reached",
      deviceNumber: "Device Number",
      deviceType: "Device Type",
      deviceCommunicationType: "Device Communication Type",
      serialNumber: "Serial Number",
      supervisionTime: "Supervision Time",
      accessAreas: "Access Areas",
      egressAreas: "Egress Areas",
      displayAreas: "Display Areas",
      strikeTime: "Strike Time",
      strikeDelay: "Strike Delay",
      fireExit: "Fire Exit",
      autoForceArm: "Auto Force Arm",
      publicDoor: "Public Door",
      privateDoor: "Private Door",
      outputGroup: "Output Group",
      doorRealTimeStatus: "Door Real-time Status",
      override: "Override",
      sendDoorForcedMessage: "Send Door Forced Message",
      program734Options: "Program 734 Options",
      activateZone2Bypass: "Activate Zone 2 Bypass",
      relockOnZone2Change: "Relock on Zone 2 Change",
      zone2BypassTime: "Zone 2 Bypass Time",
      activateZone3ReqToExit: "Activate Zone 3 Req to Exit",
      zone3ReqToExitStrikeTime: "Zone 3 Req to Exit Strike Time",
      activateOnboardSpeaker: "Activate Onboard Speaker",
      noCommunicationWithPanel: "No Communication with Panel",
      cardFormat: "Card Options",
      wiegandCodeLength: "Wiegand Code Length",
      siteCodeLength: "Site Code Length",
      userCodePosition: "User Code Position",
      siteCodePosition: "Site Code Position",
      userCodeLength: "User Code Length",
      requireSiteCode: "Require Site Code",
      numberOfUserCodeDigits: "Number of User Code Digits",
      siteCode: "Site Code",
      enable734ToConfigureOptions: "Enable Program 734 Options to configure additional settings",
      confirmDeleteDevice: "Are you sure you want to delete device '{name}'?",
      deviceCreated: "Device created successfully",
      deviceUpdated: "Device updated successfully",
      deviceDeleted: "Device deleted successfully",
      errorSavingDevice: "Error saving device",
      errorDeletingDevice: "Error deleting device",
      cardOptions: "Card Options",
      siteCodes: "Site Codes",
      addCardFormat: "Add Card Format",
      cardFormats: "Card Formats",
      selectOrAddCardFormat: "Select Or Add Card Formats",
      noCardFormats: "No Card Formats",
      newCardFormat: "New Card Format",
      editCardFormat: "Edit Card Format"
    },
    areaSchedules: {
      title: "Area Schedules",
      addNew: "Add New",
      loading: "Loading area schedules",
      noSchedulesConfigured: "No area schedules configured",
      details: "Area Schedule Details",
      areaNumber: "Area Number",
      areaNumberRange: "Valid range: 01-32",
      schedules: "Schedules",
      schedulesHint: "Assign up to 8 schedules to this area. Leave blank if not needed.",
      schedule: "Schedule",
      number: "Number",
      selectArea: "Select an area to view its details",
      selectSchedule: "Select Schedule",
      confirmDelete: "Delete Area Schedule?",
      confirmDeleteMessage: "This action cannot be undone",
      messages: {
        scheduleSaveSuccess: "Area schedule saved successfully",
        scheduleSaveError: "Error saving area schedule",
        scheduleDeleteSuccess: "Area schedule deleted successfully",
        scheduleDeleteError: "Error deleting area schedule",
      },
      notAssigned: "Not assigned"
    },
    timeSchedules: {
      title: "Time Schedules",
      addNew: "Add New",
      loading: "Loading schedules",
      noSchedulesConfigured: "No schedules configured",
      details: "Schedule Details",
      scheduleNumber: "Schedule Number",
      scheduleNumberRange: "Valid range: 01-99",
      scheduleName: "Schedule Name",
      temporarySchedule: "Temporary Schedule",
      beginDate: "Begin Date",
      endDate: "End Date",
      openBeginActivate: "Open / Begin / Activate",
      closeEnd: "Close / End",
      sunriseSunset: "Sunrise / Sunset",
      beforeAfter: "Before / After",
      select: "Select",
      sunrise: "Sunrise",
      sunset: "Sunset",
      number: "Number",
      name: "Name",
      selectSchedule: "Select a schedule to view its details",
      confirmDelete: "Delete Schedule?",
      confirmDeleteMessage: "This action cannot be undone",
      days: {
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sun: "Sun",
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat",
      },
      holidays: {
        holidayA: "Holiday A",
        holidayB: "Holiday B",
        holidayC: "Holiday C",
      },
      messages: {
        scheduleSaveSuccess: "Schedule saved successfully",
        scheduleSaveError: "Error saving schedule",
        scheduleDeleteSuccess: "Schedule deleted successfully",
        scheduleDeleteError: "Error deleting schedule",
      },
      beforeAfterOptions: {
        "5minbefore": "5 Min. Before",
        "10minbefore": "10 Min. Before",
        "15minbefore": "15 Min. Before",
        "30minbefore": "30 Min. Before",
        "45minbefore": "45 Min. Before",
        "60minbefore": "60 Min. Before",
        "5minafter": "5 Min. After",
        "10minafter": "10 Min. After",
        "15minafter": "15 Min. After",
        "30minafter": "30 Min. After",
        "45minafter": "45 Min. After",
        "60minafter": "60 Min. After",
      },
      noTimeSelected: "No time selected",
      resetButton: "Reset",
      closeButton: "Close",
      copyTime: "Copy time",
      pasteTime: "Paste time",
      applyToAll: "Apply to all"
    },
    templateConfig: {
      visualize: "Visualize",
      template: "Template",
      template_name: "Template name",
      created_at: "Created at",
      updated_at: "Updated at",
      available: "Available",
      busy: "Busy",
      generateTemplate: "Generate template",
      applyTemplate: "Apply template",
      generateTemplateWarning: "Generating the template from the panel may take a few minutes",
      deleteTemplate: "Delete template",
      deleteTemplateWarning: "The template can not be recovered",
      generatingTemplate: "Generating template",
      generatedCorrectly: "Template generated correctly",
      applyExisting: "Apply from existing templates",
      selectTemplate: "Select the template",
      edit: "Edit template",
      saveTemplate: "Save template",
      saveTemplateMock: "Template saved (mock)",
      saveTemplateSuccess: "Template saved successfully",
      saveTemplateError: "Error saving template",
      saveTemplateValidationError: "Please correct the errors in the form before saving",
      confirmExitTitle: "Exit without saving?",
      confirmExitText: "Unsaved template changes will be lost.",
      createFromScratch: "Create from scratch",
      createTemplate: "Create template",
      creatingTemplate: "Creating template",
      createdCorrectly: "Template created successfully",
      createTemplateError: "Error creating template",
      templateNamePlaceholder: "Template name",
      templateDescriptionPlaceholder: "Description (optional)",
      nameRequired: "Name is required",
      applying: "Applying template",
      appliedSuccess: "Template applied successfully",
      errorApplying: "Error applying template",
      tryAgain: "Please verify the template content and try again",
      step: "Step",
      errorStep: "This step was not completed"

    },
    systemReport: {
      title: "System Report",
      loading: "Loading",
      zoneRestorals: "Zone restorals",
      accessKeypadEnable: "Access keypad enable",
      optionsSection: "Options",
      abortReports: "Abort reports",
      bypassReports: "Bypass reports",
      scheduleChangeReports: "Schedule change reports",
      codeChangeReports: "Code change reports",
      ambushReports: "Ambush reports",
      videoSystemReports: "Video system reports",
      lateToOpen: "Late to open",
      earlyToClose: "Early to close",
      savedSuccessfully: "System report saved",
      errorSaving: "Error saving system report"
    },
    menuDisplay: {
      title: "Menu Display",
      loading: "Loading",
      optionsSection: "Options",
      armedAreaStatusDisplay: "Armed area status display",
      timeDisplay: "Time display",
      armDisarmDisplay: "Arm disarm display",
      savedSuccessfully: "Menu display saved",
      errorSaving: "Error saving menu display"
    },
    statusList: {
      title: "Status List",
      loading: "Loading",
      optionsSection: "Options",
      systemTroubleStatusMonitors: "System trouble status monitors",
      fireZoneKeypads: "Fire zone keypads",
      carbonMonoxideZoneKeypads: "Carbon monoxide zone keypads",
      burglaryZoneKeypads: "Burglary zone keypads",
      supervisoryZoneKeypads: "Supervisory zone keypads",
      panicZoneKeypads: "Panic zone keypads",
      emergencyZoneKeypads: "Emergency zone keypads",
      auxiliary1ZoneKeypads: "Auxiliary1 zone keypads",
      auxiliary2ZoneKeypads: "Auxiliary2 zone keypads",
      commPathTrouble: "Comm path trouble",
      yes: "Yes",
      no: "No",
      all: "All",
      savedSuccessfully: "Status list saved",
      errorSaving: "Error saving status list"
    },
    pcLogReport: {
      title: "PC Log Reports",
      loading: "Loading",
      optionsSection: "Options",
      netOptionsSection: "Net options",
      armDisarmReports: "Arm disarm reports",
      zoneReports: "Zone reports",
      useCommandReports: "Use command reports",
      doorAccessReports: "Door access reports",
      supervisoryReports: "Supervisory reports",
      realTimeStatus: "Real time status",
      netIpAddress: "Net IP address",
      netPort: "Net port",
      savedSuccessfully: "PC Log report saved",
      errorSaving: "Error saving pc log report"
    },
    templates: "Templates",
    inProgress: "In progress",
    virtual_bypass: "Virtual Bypass",
    virtual_bypass_on: "Enabled",
    virtual_bypass_off: "Disabled",
  }
}
